import React, { useState, useCallback, useEffect } from "react";
import { v1 as uuidv1 } from "uuid";
import CustomDialog from "../../sharedComponents/dialog/dialog";
import ButtonContainer from "../buttoncontainer/buttonContainer";

export default function UploadFile(props) {
  const [file, setFile] = useState(null);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState([]);

  useEffect(() => {
    if (props.acceptableFileFormats) {
      let formats = props.acceptableFileFormats.replace(/[\*\.\s]/g, "");
      let allowedFormats = formats.split(",");
      if (allowedFormats.length > 0) setAllowedFileExtensions(allowedFormats);
      //console.log("allowedFormats", allowedFormats);
    }
  }, [props.acceptableFileFormats]);

  const handleCancel = () => {
    props.handleClose();
  };

  const renderDialogActions = () => (
    <ButtonContainer
      handleClick={() => props.changeFile(file)}
      handleCancel={handleCancel}
      buttonText={"Upload"}
      //disableButton={imageSrc == null}
    />
  );
  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!allowedFileExtensions.includes(extension.toLowerCase())) {
        alert(
          `Please select files with one of ${allowedFileExtensions.join(
            ", "
          )} formats.`
        );
        handleCancel();
        return;
      }

      props.handleSourceFileName(file.name.replace(`.${extension}`, ""));

      let blob = file.slice(0, file.size, file.type);
      let newFileName = uuidv1() + "." + extension;
      const newFile = new File([blob], newFileName, { type: file.type });
      setFile(newFile);
    }
  };

  const renderDialogContent = () => (
    <input
      type="file"
      onChange={onFileChange}
      //className={classes.fileInput}
      accept={props.acceptableFileFormats}
    />
  );

  return (
    <>
      <CustomDialog
        title={props.title}
        handleClose={props.handleClose}
        open={props.open}
        fullWidth={true}
        renderContent={renderDialogContent}
        renderActions={renderDialogActions}
      />
    </>
  );
}
